<template>
  <div>
    <div class="content-title">
      <div>
        <span>C.E. 2003 -</span>
        <h2>防疫英雄</h2>
      </div>
    </div>
    <div class="content-img">
      <picture>
        <source srcset="../../assets/images/coronavirus/coronavirus-m.png" media="(max-width: 480px)">
        <img src="../../assets/images/coronavirus/coronavirus.png" alt="">
      </picture>
    </div>
    <div class="wrapper">
      <p style="text-align: center"><small>撰文/陳亭均</small></p>
      <p>2003年4月SARS撲台，和平醫院宣布封院，院內感染。此疫情造成7名醫護人員殉職，73人死亡，疫情慘烈。</p>
      <p>「那時我人在國外，看到晚報有個小角落，報導廣東一家醫院傳出不明原因肺炎，醫護人力不夠。」現任衛福部傳染病防治諮詢會預防接種組召集人、台大醫院小兒感染科主治醫師李秉穎，當時早在SARS撲台前夕，就像一口被敲響的警鐘，在報紙上為文，認為這正是新型疾病流行的前兆。</p>
      <p>然而，當年台灣疾病管制局（現為疾管署）在規模設備、人力配置、動員量能上，都明顯有不足之處，地方和中央防疫措施無法統一；更重要的是，大家對疫病流行「等閒視之」，直到勤姓台商確定染疫，SARS才開始被視為災難。</p>
      <figure class="article-img">
        <img src="../../assets/images/coronavirus/pic-04.png" alt="">
        <figcaption>SARS大流行期間，和平醫院因發生院內感染，宣布封院。(圖片來源/中央社）</figcaption>
      </figure>
      <p>同年7月，行政院核定成立「感染症防治醫療網」。接連完成辦理第一、二期「感染症防治醫療網」防治醫院簽約。</p>
      <p>SARS過後，疾管局更明定，在疫情下有需求時，得成立中央流行疫情指揮中心，統籌資源及政策。由先前疾管局八百多名人員編制只有七位醫師，修法增加了30位防疫醫師名額，防疫人力才被重視；感染症防治醫療網也逐步建立，縣市都有配置負壓隔離病房的應變醫院，每年演練、教育訓練也相對積極。</p>
      <p>「因為SARS，開始有了防疫醫師制度，重視病毒學檢驗，現在才能比較有效率。」李秉穎說。</p>
      <p>2005年，「國家衛生指揮中心」（NHCC）正式啟用。2006年行政院核定「感染症防治醫療網」由原台北、中、南、東、高高屏區5區，新增為台北、北、中、南、東、高高屏6區，以因應區域指揮中心暨指揮官運作。</p>
      <figure class="article-img">
        <img src="../../assets/images/coronavirus/pic-01.png" alt="">
        <figcaption>前副總統陳建仁為國際知名流行病學者，17年前台灣 SARS 爆發院內感染，曾接下衛生署署長重擔。</figcaption>
      </figure>
      <p>到了2009年，H1N1襲來，有了SARS慘烈的經驗，台灣這次做好了防疫準備，H1N1在台死亡率，在全世界排名第三低。前副總統陳建仁長年投入抗疫，他曾說：「每朵烏雲都可能鑲金邊」，台灣已經從SARS這朵烏雲上學到了教訓。</p>
      <figure class="article-img">
        <img src="../../assets/images/coronavirus/pic-02.png" alt="">
        <figcaption>「中央流行疫情指揮中心」在新冠肺炎疫情中，統整全國資源，並且主導政策，有效防堵國外疫病入台。</figcaption>
      </figure>
      <p>今年，新冠肺炎來襲。1月份，台灣隨即派兩名專家赴中國武漢市了解新冠肺炎，並於20日宣布成立「嚴重特殊傳染性肺炎中央流行疫情指揮中心」。該月31日徵用全國口罩工廠生產的醫療用口罩。二月，口罩實名制1.0上路。</p>
      <p>至今台灣成為全球少數能正常上學、上班活動國家，成為全球防疫成功的典範。</p>
      <figure class="article-img">
        <img src="../../assets/images/coronavirus/pic-03.png" alt="">
        <figcaption>「做科學本來就要堅持真理，不能鄉愿，如果為了減少衝突就不去挑戰，是不行的。本來就應該要講清楚。」－衛福部傳染病防治諮詢會預防接種組召集人、台大醫院小兒感染科主治醫師李秉穎</figcaption>
      </figure>
      <p>身為疫苗專家，李秉穎卻也在H1N1抗疫過程中，嘗到挫敗感。「當時，流感疫苗副作用被誇大了。」當年民眾對國產疫苗信心不足，「劉小弟事件」後更急轉直下，儘管專家聲稱劉小弟之死非疫苗之故，但還是出現拒打現象。</p>
      <p>「我認為，疫苗知識應該要列入醫學院學分，最好也列入國民教育。像流感疫苗，公民教育裡完全沒有提到。」</p>
      <p>過去17年，台灣曾打過三場嚴峻的疫情戰役。2003年的SARS，2009年的H1N1新型流感，直到這次的新冠肺炎，李秉穎也是當前台灣抗疫有成的關鍵人物，一路親眼目睹台灣防疫系統和知識從混亂漸趨嚴謹的過程，錯誤與正確的觀念不斷辯證，讓台灣從困厄中逐漸長大。</p>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style>
</style>
